import { useState } from 'react';
import { MantineTabs } from '@dealstack/frontend/shared/components/MantineTabs/MantineTabs.tsx';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';
import { CohortsTab } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Classifiers/components/CohortsTab/CohortsTab.tsx';
import { TagsTab } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Classifiers/components/TagsTab/TagsTab.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { ClassifiersTab } from './utils/types';

export const Classifiers = () => {
	const tMipManage = useTranslationMipManage();
	const [activeTab, setActiveTab] = useState<ClassifiersTab>('cohorts');

	const tabsConfig: MantineTabProps<ClassifiersTab>[] = [
		{
			label: tMipManage('root.classifiers.tabs.cohorts'),
			value: 'cohorts',
		},
		{
			label: tMipManage('root.classifiers.tabs.tags'),
			value: 'tags',
		},
	];

	return (
		<MantineTabs<ClassifiersTab>
			tabs={tabsConfig}
			value={activeTab}
			onTabChange={(value) => setActiveTab(value as ClassifiersTab)}
			onlyDividerBorder
			panels={[
				{ value: 'cohorts', content: <CohortsTab /> },
				{ value: 'tags', content: <TagsTab /> },
			]}
		/>
	);
};
